import clsx from "clsx";
import { ReactNode } from "react";

import * as styles from "./OneTrustButton.css";

const OneTrustButton: ReactNode = (
  <button
    id="ot-sdk-btn"
    className={clsx(styles.otButton, "ot-sdk-show-settings")}
    suppressHydrationWarning
  >
    Cookie Settings
  </button>
);

export default OneTrustButton;
